module.exports = __webpack_public_path__ + "static/media/companiesBG.9ad204c5.svg";